<template>
  <div id="user-profile">
    <profile-header />
    <!-- publicacion info  -->
    <section id="profile-info">
      <b-row>
        <b-col
          lg="12"
          cols="12"
          order="1"
          order-lg="2"
        >
          <descripcion />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          lg="12"
          cols="12"
          order="1"
          order-lg="2"
        >
          <ediciones />
        </b-col>
      </b-row>
    </section>
    <!--/ publicacion info  -->
  </div>
</template>

<script>

import { BRow, BCol } from 'bootstrap-vue'
import Ediciones from './components/Ediciones.vue'
import Descripcion from './HomeDescripcion.vue'
import ProfileHeader from './HomeHeader.vue'

/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    ProfileHeader,
    Descripcion,
    Ediciones,
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss" >
@import '@core/scss/vue/pages/page-profile.scss';
</style>
